(function() {
    'use strict';
    angular
        .module('ccsTrApp')
        .factory('InvoicePrice', InvoicePrice);

    InvoicePrice.$inject = ['$resource'];

    function InvoicePrice ($resource) {
        var resourceUrl =  'api/invoice-prices/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'save': { method:'POST' }
        });
    }
})();
